// import { Link, useLocation } from "react-router-dom";
// import { LogIn, MessageSquare } from "lucide-react";
// import "./LoginToReview.css";

// export default function LoginToReview({comments,user}) {
//     const location = useLocation();

//     function getReviewClass(user, comments) {
//         if (user.user === null && comments > 0) return "login-review-one";
//         if (user.user === null && comments === 0) return "login-review-none";
//         if (user.user && comments > 0) return "login-review";
//       //  return "login-review";
//     }

//     return (
//         // <div className={getReviewClass(user, comments)}>
//         <div   
//          className={
//     (user  === null) && comments === 0
//       ? "login-review-none"
//       : user  === null && comments > 0
//       ? "login-review-one"
//       : "login-review"
//   }
//         >


//             <div className="login-review-icon">
//                 <MessageSquare size={42} stroke="#87a91f" />
//             </div>

//             <h3>ثبت نظر</h3>

//             <p>
//                 برای ثبت نظر درباره این محصول ابتدا وارد حساب کاربری خود شوید.
//             </p>

//             <Link
//                 to="/login"
//                 state={{ redirectTo: location.pathname }}
//                 className="login-review-btn"
//             >
//                 <LogIn size={18} stroke="#fff" />
//                 ورود به حساب
//             </Link>

//         </div>
//     );
// }

import { LogIn, MessageSquare } from "lucide-react";
import { useState } from "react";
import "./LoginToReview.css";

import LoginModal from "../../Auth/LoginModal";

export default function LoginToReview({ comments, user }) {
    const [loginOpen, setLoginOpen] = useState(false);

    const isAuthenticated = !!user;

    const reviewClass =
        !isAuthenticated && comments === 0
            ? "login-review-none"
            : !isAuthenticated && comments > 0
            ? "login-review-one"
            : "login-review";

    return (
        <>
            <div className={reviewClass}>
                <div className="login-review-icon">
                    <MessageSquare size={42} stroke="#87a91f" />
                </div>

                <h3>ثبت نظر</h3>

                <p>
                    برای ثبت نظر درباره این محصول ابتدا وارد حساب کاربری خود شوید.
                </p>

                <button
                    type="button"
                    className="login-review-btn"
                    onClick={() => setLoginOpen(true)}
                >
                    <LogIn size={18} stroke="#fff" />
                    ورود به حساب
                </button>
            </div>

            <LoginModal
                open={loginOpen}
                onClose={() => setLoginOpen(false)}
            />
        </>
    );
}